import { useState } from "react";
import { useSelector } from "react-redux";
import React from "react";
import { TerminalState } from "../../../slices/terminal-summary/TerminalDetailsState";
import { terminalDetailsSelector } from "../../../slices/terminal-summary/terminalDetailsSlice";
import SlideOutSidebar from "../../../ui-components/slide-out-sidebar/slideOutSidebar";
import Loading from "ui-components/loading/loading";
import { ReactComponent as EditIcon } from "images/edit_solid.svg";
import _ from "lodash";
import { Divider } from "features/terminal-details/common/divider";
import EditGeneralInfo from "./editDetails/editBasic";
import './basicInfo.scss'
import { UserUtils } from "app/data/user/userUtils";
import UserState from "slices/user/UserState";
import { userSelector } from "slices/user/userSlice";

const ProfileHeader = (props: { handleEdit?: () => void }): React.ReactElement => {
    const userState: UserState = useSelector(userSelector);
    const { handleEdit } = props;
    return (
        <div className="profile-header border-bottom">
            <div className="profile-header__title">
            <span className="profile-header__title-text">{"General Information"}</span>
            </div>
            {UserUtils.isXGSAdministrator(userState.profile) && <div className="edit" onClick={handleEdit}>
                <span>
                    <EditIcon width={15} height={15} style={{ color: "#2F80ED" }} />
                </span>Edit</div>
            }
        </div>
    )
}

const ProfileSection = (): React.ReactElement => {
    const [isEditing, setIsEditing] = useState(false);

    const terminalState: TerminalState = useSelector(terminalDetailsSelector);

    const loading = terminalState.data === null && <Loading isLoading={true}></Loading>

    const operatingHours = terminalState.data?.terminalOpenHoursList.filter((item: any) => item.type === "OPERATION").map((item: any) => item.openHours).join(", ").replace(" ", "\n");
    const willCallHours = terminalState.data?.terminalOpenHoursList.filter((item: any) => item.type === "WILL_CALL").map((item: any) => item.openHours).join(", ").replace(" ", "\n");

    const infoData = [
        { label: 'Terminal Number', value: terminalState.data?.terminalNumber?.toString() || loading },
        { label: 'Airport Code', value: terminalState.data?.airportCode || loading },
        { label: 'Terminal Type', value: terminalState.data?.terminalType?.type || loading },
        { label: 'Status', value: terminalState.data?.status ? (terminalState.data?.status === "ACTIVE" ? <div className="status-active">{terminalState.data?.status}</div> : <div className="status-inactive">{terminalState.data?.status}</div>) : loading },
        { label: 'Division', value: terminalState.data?.division || loading },
        { label: 'Region', value: terminalState.data?.region?.regionName || loading },
        { label: 'Timezone', value: terminalState.data?.timezone || loading },
        { label: 'WMS Warehousing', value: typeof terminalState.data?.warehouse === "boolean" ? (terminalState.data?.warehouse ? "Yes" : "No") : loading },
        { label: 'Operating Hours', value: operatingHours || loading },
        { label: 'Will Call Hours', value: willCallHours || loading },
        { label: 'Last Updated', value:  terminalState.data?.dateUpdated ? 
            <div>
                {terminalState.data?.dateUpdated?.toUiMonthDateFormat()}
                {terminalState.data?.updatedBy ? <div className="updated-by"> 
                by {terminalState.data?.updatedBy}</div> : ""}
            </div>
            : loading },
    ];

    return (
        <>
            <SlideOutSidebar
                show={isEditing}
                onClose={() => { setIsEditing(false) }}
                header="Edit General Information"
                size="small"
            >
                <>

                    <div className="profile-header edit-header">
                        <div className="profile-header__title">
                        <span className="profile-header__edit-title-text">{terminalState.data?.terminalName}</span>
                        </div>
                        <div className="profile-header__status">
                            {terminalState.data?.status ? terminalState.data?.status === "ACTIVE" ? <div className="status-active">{terminalState.data?.status}</div> : <div className="status-inactive">{terminalState.data?.status}</div> : <Loading isLoading={true} />}
                        </div>


                    </div>
                    <Divider className="margin-20" />

                    <EditGeneralInfo onClose={() => setIsEditing(false)} />
                </>
            </SlideOutSidebar>
            <div className="flex-table">
                <ProfileHeader handleEdit={() => setIsEditing(true)} />
                <div>
                    {infoData.map(({ label, value }, index) => (
                        <div className="flex-row" key={index}>
                            <span className="label">{label}:</span>
                            <span className="basic-info-value">{_.isEmpty(value) ? "N/A" : value}</span>
                        </div>
                    ))}
                </div>
            </div>
        </>
    )
}

export default ProfileSection;